import React, {useContext, useState} from 'react';
import LandingPage from '../../../Pages/LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';
import WQSearchTable from './WQSearchTable';
import WQAccountsTable from './WQAccountsTable';
const index = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);
  const [workQueueRowData, setWorkQueueRowData] = useState(null);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <>
      <LandingPage
        title={'Work Queue Activity'}
        showTabs={true}
        tabValue={tabValue}
        handleTabChange={handleChange}
        allAntTabs={[]}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {tabValue === 0 && (
                  <WQSearchTable setTabValue={setTabValue} setWorkQueueRowData={setWorkQueueRowData} />
                )}
                {tabValue === 1 && (
                  <WQAccountsTable setTabValue={setTabValue} workQueueRowData={workQueueRowData} />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};
export default index;
